export const LOCAL_PERSISTENCE_SERVICE = Symbol('LocalPersistence');
